import { useTranslation } from 'react-i18next';
import { CellType, ICell } from '../../../../base';

export const useTableCells = (): ICell[] => {
    const { t } = useTranslation();

    const cells: Array<ICell> = [
        {
            id: 'id',
            headerTitle: t('teamMembersTable.pargodaId'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'id' },
            isSortable: true,
        },
        {
            id: 'name',
            headerTitle: t('teamMembersTable.name'),
            type: CellType.Person,
            cellFields: { name: 'name', icon: 'icon' },
            isSortable: true,
        },
        {
            id: 'jobTitle',
            headerTitle: t('teamMembersTable.jobTitle'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'jobTitle' },
            isSortable: true,
        },
        {
            id: 'email',
            headerTitle: t('teamMembersTable.email'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'email' },
            isSortable: true,
        },
        {
            id: 'role',
            headerTitle: t('teamMembersTable.role'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'role' },
            isSortable: false,
        },
        {
            id: 'status',
            headerTitle: t('teamMembersTable.status'),
            type: CellType.Label,
            cellFields: { labelText: 'statusLabel', labelColor: 'statusColor' },
            isSortable: true,
        },
        {
            id: 'actionMenu',
            headerTitle: '',
            type: CellType.Menu,
            cellFields: { menuActions: 'menuActions' },
        },
    ];
    cells.forEach((cell, index) => {
        cell.columnIndex = index;
    });

    return cells;
};
